module.exports = __webpack_public_path__ + "img/BQV_LOGO_red.95e27d6a.png";